import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import PrimaryCircularProgress from '../ProgressBackdrop/compoenents/PrimaryCircularProgress'

const TableLoaderElement = ({ colSpan = 8 }: { colSpan?: number }) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={colSpan}>
          <Stack paddingY={'200px'} justifyContent={'center'} direction={'row'}>
            <Box sx={{ width: '40px' }}>
              <PrimaryCircularProgress color='inherit' thickness={1} />
            </Box>
          </Stack>
        </TableCell>
      </TableRow>
    </TableBody>
  )
}

export default observer(TableLoaderElement)
